import React from "react";
import { selectors } from "@ReduxStore/reducers";
import { useSelector } from "react-redux";
import "./GotMobile.scss";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const { getMobileAppData, getIsAccessPerks } = selectors;

function MobileContent() {
  const helpNumber = useSelector(selectors.getHelpPhoneNumber);
  const mobileAppData = useSelector(getMobileAppData);
  const isPerks = useSelector(getIsAccessPerks);

  const PERKS_APP_INFO = {
    icon: require("../../routes/home/images/mobileApp/perks_icon.png"),
    appStoreUrl: "https://apps.apple.com/us/app/access-perks/id694334046",
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.access.typerks&hl=en_US",
  };
  return (
    <div className="GotMobile">
      <header className="GotMobile-header">
        <h2 className="GotMobile-headerTitle">
          <Trans>Got Mobile?</Trans>
        </h2>
      </header>
      <section className="GotMobile-body">
        <div className="mobile-icon">
          <img
            src={isPerks ? PERKS_APP_INFO.icon : mobileAppData.mobile_logo}
            title={isPerks ? "Access Perks" : mobileAppData.app_name}
            alt={isPerks ? "Access Perks" : mobileAppData.app_name}
          />
        </div>
        <div className="apps">
          <h2>
            <Trans>Get the App!</Trans>
          </h2>
          <span className="apple">
            <a
              href={isPerks ? PERKS_APP_INFO.appStoreUrl : mobileAppData.apple_app_url}
              title="App Store"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={require("../../routes/home/images/mobileApp/App_Store_Badge.png")}
                alt="App Store"
              />
            </a>
          </span>
          <span className="android">
            <a
              href={isPerks ? PERKS_APP_INFO.playStoreUrl : mobileAppData.google_app_url}
              target="_blank"
              title={t`Google Play`}
              rel="noopener noreferrer"
            >
              <img
                src={require("../../routes/home/images/mobileApp/GooglePlay_badge.png")}
                alt={t`Google Play`}
              />
            </a>
          </span>
        </div>
        <p>
          <Trans>
            The app is free to download but requires a valid membership. As a member you are
            authorized to use this app.
          </Trans>
        </p>
        <p>
          <Trans>For technical help, please call us at</Trans> {helpNumber}.
        </p>
      </section>
    </div>
  );
}

export default MobileContent;
